<div id="counselor-sync-page" class="app-l-page-wrap">
    <div class="app-l-container">
        <page-loader *ngIf="!hasLoaded"></page-loader>

        <div class="counselor-sync-card" *ngIf="hasLoaded">
            <div class="counselor-sync-header" *ngIf="user.subscriptionExists">
                <div class="counselor-sync-header__text">
                    <h2 translate>sync.title{{ customOrgTextKey }}</h2>
                    <p translate>sync.bodySubscribe{{ customOrgTextKey }}</p>
                </div>
                <button
                    type="button"
                    autofocus
                    (click)="onInvite()"
                    class="app-c-btn app-c-btn--primary app-c-btn--curve counselor-sync-header__action">
                    <svg-icon icon="invite-icon"></svg-icon>
                    <span translate>sync.syncwCounselor{{ customOrgTextKey }}</span>
                </button>
            </div>

            <div class="counselor-sync-header" *ngIf="!user.isFullAccess">
                <div class="counselor-sync-header__text">
                    <h2 translate>sync.title{{ customOrgTextKey }}</h2>
                    <p translate>sync.body{{ customOrgTextKey }}</p>
                </div>
                <button
                    type="button"
                    autofocus
                    (click)="onSubscribe()"
                    class="app-c-btn app-c-btn--primary app-c-btn--curve counselor-sync-header__action">
                    <svg-icon icon="invite-icon"></svg-icon>
                    <span translate>sync.subscribeorAssociate</span>
                </button>
            </div>

            <section class="counselor-sync-section">
                <h3 class="counselor-sync-section__title" translate>
                    sync.synchedHeader{{ customOrgTextKey }}
                </h3>

                <div
                    class="counselor-list"
                    *ngIf="(counselors | filter: 'isPaired': true | filter: 'confirmed': true)?.length > 0; else noneSynched">
                    <div
                        class="counselor-row"
                        *ngFor="let counselor of counselors | filter: 'isPaired': true | filter: 'confirmed': true">
                        <div class="counselor-row__info">
                            <div class="counselor-row__name">{{ counselor.name }}</div>
                            <div class="counselor-row__email">{{ counselor.email }}</div>
                        </div>
                        <div class="counselor-row__actions">
                            <button
                                type="button"
                                aria-label="Cancel sharing"
                                (click)="onCancel(counselor.id)"
                                class="app-c-btn app-c-btn--secondary app-c-btn--curve">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>

                <ng-template #noneSynched>
                    <div class="counselor-empty">
                        <p translate>sync.noneSynched{{ customOrgTextKey }}</p>
                    </div>
                </ng-template>
            </section>

            <section
                class="counselor-sync-section"
                *ngIf="(counselors | filter: 'isPaired': true | filter: 'confirmed': false)?.length > 0">
                <h3 class="counselor-sync-section__title" translate>sync.pendingHeader</h3>

                <div class="counselor-list">
                    <div
                        class="counselor-row counselor-row--pending"
                        *ngFor="let counselor of counselors | filter: 'isPaired': true | filter: 'confirmed': false">
                        <div class="counselor-row__info">
                            <div class="counselor-row__name">{{ counselor.name }}</div>
                            <div class="counselor-row__email">{{ counselor.email }}</div>
                        </div>
                        <div class="counselor-row__actions">
                            <button
                                type="button"
                                aria-label="Accept invitation"
                                (click)="onAccept(counselor.id)"
                                class="app-c-btn app-c-btn--primary app-c-btn--curve">
                                Accept
                            </button>
                            <button
                                type="button"
                                aria-label="Decline invitation"
                                (click)="onReject(counselor.id)"
                                class="app-c-btn app-c-btn--secondary app-c-btn--curve">
                                Decline
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <div
                class="counselor-empty"
                *ngIf="((!counselors || counselors.length === 0) && (counselors | filter: 'isPaired': true | filter: 'confirmed': true)?.length !== 0)">
                <p translate>sync.noneFound{{ customOrgTextKey }}</p>
            </div>
        </div>
    </div>
</div>
